<template>
  <div name="1">
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-map-search</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.brochure') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!--v-divider vertical  style="margin: 0 10px 0 10px;"/-->
      <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ title }}</h5>
    </v-toolbar>
    <select-image
      v-show="!collapseContent"
      v-model="content.BrochureImage"
      :isFullWidth="true"
      :imageWidth="960"
      :imageHeight="371"
      :aspectRatio="21/9"
      :enterpriseID="enterpriseID"
      :imageOld='content.BrochureImage'
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.BrochureTitle"
      :languages="languages"
      :label="$t('site.title')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.BrochureSubtitle"
      :languages="languages"
      :label="$t('site.subtitle')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <div style="width: 100%; text-align:right;">
      <v-switch
        v-show="!collapseContent"
        v-model="collpaseDetails"
        :label="$t('common.collapse', locale)"
      />
    </div>
    <v-layout
      v-show="!collapseContent && !collpaseDetails"
      wrap style="background-color: rgba(0, 0, 0, 0.1);margin-top:20px;border-radius: 10px; padding: 0 20px;"
    >
      <v-flex xs12>
        <v-checkbox
          v-model="content.BrochureWithLocation"
          :value="content.BrochureWithLocation"
          :label="$t('brochure.location')"
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-layout wrap v-if="content.BrochureWithLocation" align-center>
        <!--v-flex xs12>
          <v-text-field
            v-model="content.BrochureZone"
            :label="$t('brochure.zone')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex-->
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochureMunicipaly"
            :label="$t('brochure.municipaly')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochureAddress"
            :label="$t('brochure.address')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochurePostalCode"
            :label="$t('brochure.postalCode')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="content.BrochureLat"
            :label="$t('brochure.lat')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="content.BrochureLon"
            :label="$t('brochure.lon')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <br/>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout
      v-show="!collapseContent && !collpaseDetails"
      wrap style="background-color: rgba(0, 0, 0, 0.1);margin-top:20px;border-radius: 10px; padding: 0 20px;"
    >
      <v-flex xs12>
        <v-checkbox
          v-model="content.BrochureWithContact"
          :value="content.BrochureWithContact"
          :label="$t('brochure.contact')"
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-layout wrap v-if="content.BrochureWithContact" align-center>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochurePhone"
            :label="$t('brochure.phone')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochureFax"
            :label="$t('brochure.fax')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochureEmail"
            :label="$t('brochure.email')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="content.BrochureWeb"
            :label="$t('brochure.web')"
            hideDetails
            @input="handleChangeIsModified"
          />
          <br />
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout
      v-show="!collapseContent && !collpaseDetails"
      wrap style="background-color: rgba(0, 0, 0, 0.1);margin-top:20px;border-radius: 10px; padding: 0 20px;"
    >
      <v-flex xs12>
        <v-checkbox
          v-model="content.BrochureWithDescription"
          :value="content.BrochureWithDescription"
          :label="$t('brochure.description')"
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-layout wrap v-if="content.BrochureWithDescription" align-center>
        <v-flex xs12>
          <translate
            v-model="content.BrochureDescription"
            type="richText"
            :languages="languages"
            :label="$t('brochure.description')"
            @input="handleChangeIsModified"
            style="padding: 0 10px 0 10px;"
          />
        </v-flex>
        <v-flex xs12>
          <translate
            v-model="content.BrochureNote"
            :languages="languages"
            :label="$t('brochure.note')"
            @input="handleChangeIsModified"
            style="padding: 0 10px 0 10px;"
          />
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout
      v-show="!collapseContent && !collpaseDetails"
      wrap style="background-color: rgba(0, 0, 0, 0.1);margin-top:20px;border-radius: 10px; padding: 0 20px;"
    >
      <v-flex xs12>
        <v-checkbox
          v-model="content.BrochureWithFacts"
          :value="content.BrochureWithFacts"
          :label="$t('brochure.facts')"
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-layout wrap v-if="content.BrochureWithFacts" align-center>
        <v-flex xs12>
          <translate
            v-model="content.BrochureHours"
            :languages="languages"
            :label="$t('brochure.hours')"
            @input="handleChangeIsModified"
            style="padding: 0 10px 0 10px;"
          />
        </v-flex>
        <v-flex xs12>
          <translate
            v-model="content.BrochurePrice"
            :languages="languages"
            :label="$t('brochure.price')"
            @input="handleChangeIsModified"
            style="padding: 0 10px 0 10px;"
          />
        </v-flex>
        <v-flex xs12>
          <translate
            v-model="content.BrochureServices"
            type="textArea"
            :languages="languages"
            :label="$t('brochure.services')"
            @input="handleChangeIsModified"
            style="padding: 0 10px 0 10px;"
          />
        </v-flex>
      </v-layout>
    </v-layout>
    <!--translate
      v-show="!collapseContent"
      v-model="content.BrochureSubtitle"
      :languages="languages"
      :label="$t('site.subtitle')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    /-->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  import SelectImage from '@/components/SelectImage'
  import Translate from '@/components/Translate'
  import AddressFind from '@/components/AddressFind'
  export default {
    components: {
      SelectImage,
      Translate,
      AddressFind,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      collpaseDetails: true,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      languages () {
        return this.$store.state.app.Languages
      },
      title () {
        const aux = this.content && this.content.SiteTitle ? utils.getTranslation (this.content.SiteTitle, this.locale) : ''
        return aux ? aux.toUpperCase() : aux
      },
    },
    mounted() {
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleUpdateAddress (address) {
        this.handleChangeIsModified()
        this.content.SiteAddress = address.address
        this.content.SiteLon = address.lon
        this.content.SiteLat = address.lat
      }
    }
  }
</script>

<style scoped>
</style>

